export default (state, data) => {
	console.info('🦑 SET_CLAIM_DATA', data);
	state.claims[data.key] = data;
};
